import { Component, ElementRef, ViewChild } from '@angular/core';
import { IWizItemRenderer, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';
import { ChronoCodeLevelVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/**
 * Vignette de présentation d'un chronocode pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'md-chronocode-tile-renderer',
  templateUrl: './md-chronocode-tile.renderer.html',
})
export class MdChronoCodeTileRenderer implements IWizItemRenderer<null, ChronocodeVO> {
  @ViewChild('mdChronoCodeTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: ChronocodeVO;
  public get data(): ChronocodeVO {
    return this._data;
  }
  public set data(data: ChronocodeVO) {
    this._data = data;
    this.mdTileRenderer.data = data;
    this.mdTileRenderer.showComplementaryTitle = true;
  }

  // Le titre complémentaire est une concaténation des dates de début et de fin du chronocode
  public get startEndDate(): string {
    return this.data.startDateStr + ' - ' + this.data.endDateStr;
  }

  // Le corps de la vignette présente le découpage temporel du chronocode
  public get sequence(): string {
    let result: string;
    Object.values(this.data.chronoCodeLevelVOs).forEach((level: ChronoCodeLevelVO) => {
      if (result !== undefined) {
        result = result + ' > ' + level.trsLabel;
      } else {
        result = level.trsLabel;
      }
    });
    return result;
  }

  /** Dispatch du clic sur le bouton de duplication du chronocode */
  public onDuplicate(e: WizEvent): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DUPLICATE_DATA, this._data, this));
  }

  /**
   * Vérification si le user a les droits de duplication
   */
  public get isDuplicateAllowed(): boolean {
    return !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.CHRONOCODE);
  }
}
